import { useEffect, useRef, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { Helmet } from "react-helmet-async";
import Lightbox from "../components/Lightbox";
 
const SAMPLES = [
  {
    id: "kleo",
    type: "image",
    src: "/work/kleo-01.png",
    poster: "/work/kleo-01.png",
    client: "Kleo",
    category: "Brand Identity · Motion",
    aspect: "aspect-[16/12]",
    bg: "bg-[#0d1a4a]",
    gallery: [
      { type: "image", src: "/work/kleo-02.png" },
      { type: "image", src: "/work/kleo-03.png" },
      { type: "image", src: "/work/kleo-04.png" },
      { type: "image", src: "/work/kleo-05.png" },
      { type: "image", src: "/work/kleo-06.png" },
    ],
  },
  {
    id: "runrly",
    type: "image",
    src: "/work/runrly-01.png",
    client: "Runrly",
    category: "Logo Design",
    aspect: "aspect-[4/3]",
    bg: "bg-[#111111]",
    gallery: [{ type: "image", src: "/work/runrly-01.png" }],
  },
  {
    id: "myx",
    type: "video",
    src: "/work/myx-01.mp4",
    poster: "/work/myx-01.mp4",
    client: "Myx",
    category: "Brand Identity",
    aspect: "aspect-[9/16]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "video", src: "/work/myx-01.mp4" }],
  },
  {
    id: "myx-photo",
    type: "image",
    src: "/work/photo-01.jpg",
    poster: "/work/photo-01.jpg",
    client: "Myx",
    category: "Brand Identity",
    aspect: "aspect-[9/16]",
    bg: "bg-[#0a0a0a]",
    gallery: [
      { type: "image", src: "/work/photo-01.jpg" },
      { type: "image", src: "/work/photo-02.jpg" },
      { type: "image", src: "/work/photo-04.jpg" },
      { type: "image", src: "/work/photo-05.jpg" },
      { type: "image", src: "/work/photo-06.jpg" },
      { type: "image", src: "/work/photo-08.jpg" },
    ],
  },
  {
    id: "masterminds",
    type: "image",
    src: "/work/masterminds-01.png",
    client: "Masterminds",
    category: "Brand Identity",
    aspect: "aspect-[4/3]",
    bg: "bg-[#0d1f0d]",
    gallery: [{ type: "image", src: "/work/masterminds-01.png" }],
  },
  {
    id: "tekexa",
    type: "image",
    src: "/work/tekexa-01.png",
    client: "Tekexa",
    category: "Brand Identity",
    aspect: "aspect-[16/9]",
    bg: "bg-[#1a2de0]",
    gallery: [{ type: "image", src: "/work/tekexa-01.png" }],
  },
  {
    id: "deeezdonutz",
    type: "image",
    src: "/work/deeezdonutz-01.png",
    client: "Deeezdonutz",
    category: "Brand Identity",
    aspect: "aspect-[3/4]",
    bg: "bg-[#6b1a5e]",
    gallery: [{ type: "image", src: "/work/deeezdonutz-01.png" }],
  },
  {
    id: "wionex",
    type: "image",
    src: "/work/wionex-01.png",
    client: "Wionex",
    category: "Brand Identity",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0d2b1a]",
    gallery: [
      { type: "image", src: "/work/wionex-01.png" },
      { type: "image", src: "/work/wionex-02.png" },
    ],
  },
  {
    id: "seed",
    type: "image",
    src: "/work/seed-04.jpg",
    client: "Seed",
    category: "Brand Identity",
    aspect: "aspect-[9/16]",
    bg: "bg-[#0a0a0a]",
    gallery: [
      { type: "image", src: "/work/seed-02.jpg" },
      { type: "image", src: "/work/seed-03.jpg" },
      { type: "image", src: "/work/seed-04.jpg" },
    ],
  },
  {
    id: "nkora",
    type: "video",
    src: "/work/nkora-01.mp4",
    poster: "/work/nkora-01.mp4",
    client: "Nkora",
    category: "Brand Identity",
    aspect: "aspect-[9/16]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "video", src: "/work/nkora-01.mp4" }],
  },
  {
    id: "creative-imagery",
    type: "image",
    src: "/work/creative-01.jpg",
    client: "Creative Imagery",
    category: "Photography",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [
      { type: "image", src: "/work/creative-01.jpg" },
      { type: "image", src: "/work/creative-02.jpg" },
      { type: "image", src: "/work/creative-03.jpg" },
      { type: "image", src: "/work/creative-04.jpg" },
    ],
  },
  {
    id: "logo-design",
    type: "image",
    src: "/work/logo-design-01.jpg",
    client: "Logo Design",
    category: "Logo Design",
    aspect: "aspect-[3/4]",
    bg: "bg-[#111111]",
    gallery: [
      { type: "image", src: "/work/logo-design-01.jpg" },
      { type: "image", src: "/work/logo-design-02.jpg" },
      { type: "image", src: "/work/logo-design-03.jpg" },
    ],
  },
  {
    id: "app-design",
    type: "image",
    src: "/work/app-design-01.jpg",
    client: "App Design",
    category: "App Design",
    aspect: "aspect-[4/3]",
    bg: "bg-[#0a0a0a]",
    gallery: [
      { type: "image", src: "/work/app-design-01.jpg" },
      { type: "image", src: "/work/app-design-02.jpg" },
      { type: "image", src: "/work/app-design-03.jpg" },
    ],
  },
  {
    id: "delivery-app",
    type: "image",
    src: "/work/delivery-app-02.jpg",
    client: "Delivery App",
    category: "App Design",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [
      { type: "image", src: "/work/delivery-app-01.jpg" },
      { type: "image", src: "/work/delivery-app-02.jpg" },
    ],
  },
  {
    id: "creative-ad",
    type: "image",
    src: "/work/creative-ad-01.jpg",
    client: "Creative Ad",
    category: "Ad Creative",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/creative-ad-01.jpg" }],
  },
  {
    id: "twist",
    type: "image",
    src: "/work/twist-01.jpg",
    client: "Twist",
    category: "Ad Creative",
    aspect: "aspect-[4/3]",
    bg: "bg-[#0a0a0a]",
    gallery: [
      { type: "image", src: "/work/twist-01.jpg" },
      { type: "image", src: "/work/twist-02.jpg" },
      { type: "image", src: "/work/twist-03.jpg" },
    ],
  },
  {
    id: "website-design",
    type: "image",
    src: "/work/website-design-01.jpg",
    client: "Website Design",
    category: "Web Design",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/website-design-01.jpg" }],
  },
  {
    id: "spintip",
    type: "image",
    src: "/work/spintip-01.jpg",
    client: "Spintip",
    category: "Web Design",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/spintip-01.jpg" }],
  },
  {
    id: "mobile-app-ux",
    type: "image",
    src: "/work/mobile-app-ux-01.jpg",
    client: "Mobile App UX",
    category: "App Design",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/mobile-app-ux-01.jpg" }],
  },
  {
    id: "culture-app",
    type: "image",
    src: "/work/culture-app-01.jpg",
    client: "Culture App",
    category: "App Design",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/culture-app-01.jpg" }],
  },
  {
    id: "folium",
    type: "image",
    src: "/work/folium-01.jpg",
    client: "Folium",
    category: "App Design",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/folium-01.jpg" }],
  },
  {
    id: "level",
    type: "image",
    src: "/work/level-01.jpg",
    client: "Level",
    category: "Presentation Deck",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/level-01.jpg" }],
  },
  {
    id: "spyre",
    type: "image",
    src: "/work/spyre-01.jpg",
    client: "SpyRe",
    category: "App Design",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/spyre-01.jpg" }],
  },
  {
    id: "flow",
    type: "image",
    src: "/work/flow-01.jpg",
    client: "Flow",
    category: "App Design",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/flow-01.jpg" }],
  },
  {
    id: "daybase",
    type: "image",
    src: "/work/daybase-01.jpg",
    client: "Daybase",
    category: "App Design",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/daybase-01.jpg" }],
  },
  {
    id: "pitch-deck",
    type: "image",
    src: "/work/pitch-deck-01.jpg",
    client: "Investor Pitch Deck",
    category: "Presentation Deck",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/pitch-deck-01.jpg" }],
  },
  {
    id: "farce",
    type: "image",
    src: "/work/farce-01.jpg",
    client: "Farce",
    category: "Web Design",
    aspect: "aspect-[16/9]",
    bg: "bg-[#0a0a0a]",
    gallery: [
      { type: "image", src: "/work/farce-01.jpg" },
      { type: "image", src: "/work/farce-02.jpg" },
    ],
  },
  {
    id: "toa",
    type: "image",
    src: "/work/toa-01.jpg",
    client: "TOA",
    category: "Web Design",
    aspect: "aspect-[16/9]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/toa-01.jpg" }],
  },
  {
    id: "vaultx",
    type: "image",
    src: "/work/vaultx-01.jpg",
    client: "Vault X",
    category: "Web Design",
    aspect: "aspect-[4/3]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/vaultx-01.jpg" }],
  },
  {
    id: "anc",
    type: "image",
    src: "/work/anc-01.jpg",
    client: "ANC",
    category: "Web Design",
    aspect: "aspect-[16/9]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/anc-01.jpg" }],
  },
  {
    id: "haven",
    type: "image",
    src: "/work/haven-01.jpg",
    client: "Haven",
    category: "Web Design",
    aspect: "aspect-[16/9]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/haven-01.jpg" }],
  },
  {
    id: "neurova",
    type: "image",
    src: "/work/neurova-01.jpg",
    client: "Neurova",
    category: "Ad Creative",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/neurova-01.jpg" }],
  },
  {
    id: "flaren",
    type: "image",
    src: "/work/flaren-01.jpg",
    client: "Flaren",
    category: "Brand Identity",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [
      { type: "image", src: "/work/flaren-01.jpg" },
      { type: "image", src: "/work/flaren-02.jpg" },
    ],
  },
  {
    id: "creative-ad-2",
    type: "image",
    src: "/work/creative-ad-02.jpg",
    client: "Creative Ad",
    category: "Ad Creative",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/creative-ad-02.jpg" }],
  },
  {
    id: "bold",
    type: "image",
    src: "/work/bold-01.jpg",
    client: "Bold",
    category: "Ad Creative",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [
      { type: "image", src: "/work/bold-01.jpg" },
      { type: "image", src: "/work/bold-02.jpg" },
    ],
  },
  {
    id: "app-design-2",
    type: "image",
    src: "/work/app-design-012.jpg",
    client: "App Design",
    category: "App Design",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/app-design-012.jpg" }],
  },
  {
    id: "sales-pitch",
    type: "image",
    src: "/work/sales-pitch-01.jpg",
    client: "Sales Pitch Deck",
    category: "Presentation Deck",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [
      { type: "image", src: "/work/sales-pitch-01.jpg" },
      { type: "image", src: "/work/sales-pitch-02.jpg" },
    ],
  },
  {
    id: "mobile-app",
    type: "image",
    src: "/work/mobile-app-01.jpg",
    client: "Mobile App",
    category: "App Design",
    aspect: "aspect-[3/4]",
    bg: "bg-[#0a0a0a]",
    gallery: [{ type: "image", src: "/work/mobile-app-01.jpg" }],
  },
];
 
function Tile({ s, idx, onOpen }) {
  const ref = useRef(null);
 
  useEffect(() => {
    if (s.type !== "video" || !ref.current) return;
    const v = ref.current;
    const tryPlay = () => v.play().catch(() => {});
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) tryPlay();
          else v.pause();
        });
      },
      { threshold: 0.15 }
    );
    io.observe(v);
    return () => io.disconnect();
  }, [s.type]);
 
  return (
    <a
      href="#"
      data-testid={`work-tile-${s.id}`}
      onClick={(e) => {
        e.preventDefault();
        onOpen?.(s);
      }}
      className={`group relative ${s.aspect || "aspect-[4/3]"} ${
        s.bg
      } overflow-hidden rounded-[14px] block isolate cursor-pointer break-inside-avoid mb-3 sm:mb-4`}
      style={{ animationDelay: `${idx * 60}ms` }}
    >
      {s.type === "video" && (
        <video
          ref={ref}
          src={s.src}
          poster={s.poster}
          muted
          loop
          playsInline
          autoPlay
          preload="metadata"
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
        />
      )}
      {s.type === "image" && (
        <img
          src={s.src}
          alt={s.client}
          loading="lazy"
          className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-[1.04]"
        />
      )}
 
      {!s.light && (
        <div className="absolute inset-x-0 bottom-0 h-1/2 bg-gradient-to-t from-black/70 to-transparent pointer-events-none" />
      )}
 
      <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500" />
 
      <div className="absolute inset-x-0 bottom-0 p-5 sm:p-6 flex items-end justify-between gap-4">
        <div className="min-w-0">
          <div
            className={`font-display-tight text-[20px] sm:text-[24px] leading-tight tracking-tight ${
              s.light ? "text-black" : "text-white"
            }`}
          >
            {s.client}
          </div>
          <div
            className={`mt-1 font-mono-mc text-[10px] sm:text-[11px] tracking-[0.2em] uppercase ${
              s.light ? "text-black/60" : "text-white/65"
            }`}
          >
            {s.category}
          </div>
        </div>
        <span
          className={`inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full ring-1 transition-all duration-500 group-hover:rotate-45 ${
            s.light
              ? "ring-black/20 text-black bg-white/70 group-hover:bg-white"
              : "ring-white/25 text-white bg-white/5 group-hover:bg-white/15"
          }`}
        >
          <ArrowUpRight size={14} strokeWidth={2} />
        </span>
      </div>
 
      <div className="absolute top-4 left-4 flex items-center gap-1.5">
        <span
          className={`h-1.5 w-1.5 rounded-full ${
            s.type === "video"
              ? "bg-[color:var(--blue)] animate-pulse"
              : s.light
              ? "bg-black/60"
              : "bg-white/70"
          }`}
        />
        <span
          className={`font-mono-mc text-[9px] tracking-[0.22em] uppercase ${
            s.light ? "text-black/60" : "text-white/70"
          }`}
        >
          {s.type === "video" ? "Reel" : "Case"}
        </span>
      </div>
    </a>
  );
}
 
export default function Work() {
  const [active, setActive] = useState(null);
  const open = active !== null;
 
  const handleOpen = (s) => {
    setActive(s);
  };
 
  return (
    <>
      <Helmet>
        <title>Selected Work | Midcreatives</title>
        <meta
          name="description"
          content="A glimpse of the team's capability across branding, ad creatives, UI/UX, websites, campaigns, pitch decks, logo design, and social content."
        />
      </Helmet>
 
      <section className="relative w-full bg-[#0a0a0a] min-h-screen">
        <div className="max-w-screen-2xl mx-auto px-6 md:px-10 lg:px-14 pt-10 pb-24 md:pb-32">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
 
            {/* Left sidebar */}
            <aside
              data-testid="work-aside"
              className="lg:col-span-3 lg:sticky lg:top-28 self-start"
            >
              <h2
                data-testid="work-title"
                className="font-display-tight ink leading-[1.0] tracking-[-0.02em] text-[34px] sm:text-[40px] md:text-[44px]"
              >
                Our work<span className="text-[color:var(--blue)]">.</span>
              </h2>
 
              <p className="mt-4 ink-muted text-[15px] sm:text-[16px] leading-relaxed max-w-[18rem]">
                A portfolio across creatives &amp; campaigns, branding, UI/UX, and digital products.
              </p>
 
              <div className="mt-8">
                <div className="flex items-center gap-2 font-mono-mc text-[10px] tracking-[0.22em] uppercase text-[color:var(--blue)]">
                  <span className="h-1 w-6 bg-[color:var(--blue)] rounded-full" />
                  <span>Keep going</span>
                </div>
              </div>
 
              <div className="mt-10 pt-6 border-t border-white/10 max-w-[18rem]">
                <span className="font-mono-mc text-[9px] uppercase tracking-[0.28em] text-white/35">
                  Trusted by
                </span>
                <div className="mt-4 flex flex-wrap items-center gap-x-6 gap-y-3">
                  <span className="font-display-tight ink-muted hover:text-white transition-colors text-[14px] tracking-tight">
                    Pizza Hut
                  </span>
                  <img
                    src="https://cdn.simpleicons.org/upwork/ffffff"
                    alt="Upwork"
                    className="h-3.5 w-auto opacity-45 hover:opacity-80 transition-opacity"
                    loading="lazy"
                  />
                  <span className="font-display-tight ink-muted hover:text-white transition-colors text-[14px] tracking-tight">
                    Alibaba
                  </span>
                  <span className="font-display-tight ink-muted hover:text-white transition-colors text-[14px] tracking-tight">
                    TCL
                  </span>
                </div>
                <div className="mt-5 inline-flex items-baseline gap-2">
                  <span className="font-display-tight text-[color:var(--blue)] text-[18px] leading-none">
                    100+
                  </span>
                  <span className="font-mono-mc text-[9px] uppercase tracking-[0.22em] text-white/40">
                    Projects completed
                  </span>
                </div>
              </div>
            </aside>
 
            {/* Right grid */}
            <div className="lg:col-span-9">
              <div
                data-testid="work-grid"
                className="columns-1 sm:columns-2 lg:columns-3 gap-3 sm:gap-4 space-y-3 sm:space-y-4"
              >
                {SAMPLES.map((s, i) => (
                  <Tile key={s.id} s={s} idx={i} onOpen={handleOpen} />
                ))}
              </div>
            </div>
 
          </div>
        </div>
 
        <Lightbox open={open} project={active} onClose={() => setActive(null)} />
      </section>
    </>
  );
}
